<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Commandes groupées</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col
                v-if="bDisplayOK_Corinne || bDisplayOK_PointFocal || bDisplayOK_RH || bDisplayOK_TSA || bDisplayOK_ASSA">
              <v-select :disabled="!bDisplayOK_Corinne && !bDisplayOK_RH"
                        :items="selectDates" @change="depthDate"
                        class="centered-input align-center" dense
                        filled
                        full-width
                        height="45px"
                        hide-details="true"
                        item-text="name"
                        item-value="value"
                        persistent-hint return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-else>
              <v-select
                  :disabled="!bDisplayOK_Corinne"
                  :items="selectDates" @change="depthDate"
                  class="centered-input align-center" dense
                  filled
                  full-width
                  height="45px"
                  hide-details="true"
                  item-text="name"
                  item-value="value"
                  persistent-hint return-object solo style="z-index: 200"
                  v-model="depthValToday">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne || bDisplayOK_RH">
              <v-btn @click="onexportThalia" block class="custom-btn white--text" color="#03A9F4"
                     height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-export-outline</v-icon>
                <span>Export (Thalia)</span>
              </v-btn>
            </v-col>
            <v-col v-else-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="!bDisplayOK_Corinne && !bDisplayOK_PointFocal && !bDisplayOK_RH && !bDisplayOK_TSA">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne || bDisplayOK_Restaurateur || bDisplayOK_RH || bDisplayOK_TSA">
              <v-btn @click="generatePDF" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Export PDF</span>
              </v-btn>
            </v-col>
            <v-col v-else-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne || bDisplayOK_Restaurateur || bDisplayOK_RH || bDisplayOK_TSA">
              <v-btn @click="exportXLS" block
                     class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export Excel</span>
              </v-btn>
            </v-col>
            <v-col v-else-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="bDisplayOK_Corinne || bDisplayOK_PointFocal || bDisplayOK_ASSA || bDisplayOK_TSA">
              <v-btn @click="(dialog=true) && initCmd()" block class="custom-btn white--text"
                     color="#009688"
                     height="45px" large>
                <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                <span>Passer commande</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import {heightDate} from "../../../helper/hauteur";
import * as XLSX from 'xlsx';
import imageToBase64 from "image-to-base64/browser";
import jsPDF from "jspdf";
import MotionPicture from "../../../assets/Fonts/MotionPicture-normal";
import Handsontable from "handsontable";
import _ from "lodash";
import Swal from 'sweetalert2';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import {French} from "flatpickr/dist/l10n/fr.js";

const listGuess = ['80001', '80002', '80003', '80004', '80005', '80006', '80007', '80008', '80009', '80010']

// Styles CSS améliorés pour un design plus harmonieux
const customStyles = `
<style>
  /* Palette de couleurs harmonieuses */
  :root {
    --primary-color: #00796B;       /* Vert teal foncé - couleur principale */
    --primary-light: #26A69A;       /* Vert teal plus clair */
    --secondary-color: #455A64;     /* Bleu-gris foncé - couleur secondaire */
    --secondary-light: #607D8B;     /* Bleu-gris plus clair */
    --text-on-dark: #FFFFFF;        /* Texte sur fond foncé */
    --text-on-light: #263238;       /* Texte sur fond clair */
    --background-light: #F5F8FA;    /* Fond clair */
    --success-color: #4CAF50;       /* Vert pour les succès */
    --error-color: #F44336;         /* Rouge pour les erreurs */
  }

 /* Style pour les alertes inline dans le modal */
  #modal-inline-alert {
    width: 100%;
    margin-bottom: 20px;
    transition: all 0.3s ease;
  }

  #modal-inline-alert .v-icon {
    vertical-align: middle;
  }

/* Styles pour résoudre le problème de lisibilité des select dropdown */
  .v-select__selections {
    color: white !important; /* Texte blanc sur le select fermé */
  }

  .v-menu__content .v-list-item__title,
  .v-menu__content .v-list-item__content,
  .v-select__selection--comma,
  .v-select .v-select__selection {
    color: white !important; /* Garder le texte blanc quand le select est fermé */
  }

  /* Style spécial pour les options dans le dropdown */
  .v-menu__content .v-list,
  .v-menu__content .v-list-item {
    color: #333 !important; /* Texte foncé dans le dropdown */
    background-color: white !important;
  }

  /* Style spécial pour l'option sélectionnée dans le dropdown */
  .v-menu__content .v-list-item--active {
    background-color: rgba(38, 166, 154, 0.1) !important;
    color: var(--primary-color) !important;
  }

  /* Style au survol des options */
  .v-menu__content .v-list-item:hover {
    background-color: rgba(38, 166, 154, 0.05) !important;
  }

  /* Pour les selects personnalisés dans SweetAlert, ces styles sont différents */
  #orderDate, #timeMeal, #mealName, #searchCmd {
    color: var(--text-on-light) !important; /* Texte foncé pour meilleur contraste */
    background-color: white !important; /* Fond blanc */
  }

  /* Quand les selects sont ouverts */
  .flatpickr-calendar,
  .flatpickr-calendar .flatpickr-day,
  .flatpickr-calendar .flatpickr-monthDropdown-months,
  .flatpickr-calendar .flatpickr-month,
  .flatpickr-calendar .numInputWrapper input {
    color: #333 !important; /* Texte foncé dans le calendrier */
  }

  /* Amélioration du contraste dans le calendrier */
  .flatpickr-months .flatpickr-month {
    background-color: var(--primary-color) !important;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months,
  .flatpickr-current-month .numInputWrapper span,
  .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month,
  .flatpickr-current-month .numInputWrapper input.cur-year {
    color: white !important; /* Texte blanc sur fond vert */
  }

  .flatpickr-current-month .numInputWrapper span.arrowUp:after,
  .flatpickr-current-month .numInputWrapper span.arrowDown:after {
    border-color: white transparent !important; /* Couleur des flèches */
  }

  .flatpickr-months .flatpickr-prev-month svg,
  .flatpickr-months .flatpickr-next-month svg {
    fill: white !important; /* Couleur des flèches précédent/suivant */
  }

  .flatpickr-weekdays {
    background-color: var(--background-light) !important;
  }

  span.flatpickr-weekday {
    color: var(--secondary-color) !important;
    font-weight: 600 !important;
  }

  .flatpickr-day.selected {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: white !important; /* Texte blanc sur jour sélectionné */
  }

  .flatpickr-day.today {
    border-color: var(--primary-color) !important;
    color: var(--primary-color) !important;
    font-weight: bold !important;
  }

  /* Style spécifique pour aujourd'hui quand il est sélectionné */
  .flatpickr-day.today.selected {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: white !important; /* Texte blanc pour meilleur contraste */
    font-weight: bold !important;
  }

  .flatpickr-day:hover {
    background-color: rgba(38, 166, 154, 0.2) !important;
  }

  /* Options des selects personnalisés dans SweetAlert */
  #timeMeal option, #mealName option {
    color: #333 !important; /* Texte foncé dans les options de dropdown */
    background-color: white !important;
  }

  /* Styles personnalisés pour les composants du modal */
  .swal2-popup {
    width: 90% !important;
    max-width: 1200px !important;
    font-family: 'Roboto', sans-serif;
  }

  .swal2-title {
    font-size: 18px !important;
    text-align: center !important;
    color: var(--secondary-color) !important;
    font-weight: 600 !important;
  }

  .command-form {
    padding: 16px;
  }

  .form-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    margin-bottom: 20px;
  }

  .form-group {
    flex: 1;
    min-width: 200px;
    margin: 0 10px;
    padding: 12px;
    border-radius: 8px;
    position: relative;
    background-color: white !important;
    border-left: 4px solid var(--primary-color) !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }

  .form-group:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .form-group label {
    display: block;
    text-align: center;
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 16px; /* Police agrandie de 14px à 16px */
    color: var(--primary-color) !important;
    text-transform: uppercase; /* Pour plus d'impact visuel */
    letter-spacing: 0.5px; /* Meilleur espacement des lettres */
  }

  .form-group input,
  .form-group select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    background: white !important;
    text-align: center;
    font-weight: 500;
    font-size: 15px;
    color: var(--text-on-light) !important;
  }

  .form-group input::placeholder {
    opacity: 0.7;
    text-align: center;
    color: #999 !important;
  }

  /* Style pour le conteneur Handsontable */
  #commandTableContainer {
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }

  /* Styles spécifiques pour le flatpickr */
  .flatpickr-calendar {
    z-index: 99999 !important;
  }

  /* Style pour le bouton Valider et Annuler - Design amélioré avec police plus grande */
  .swal2-actions {
    gap: 25px !important; /* Augmenté de 20px à 25px */
    flex-direction: row-reverse !important;
    margin-top: 5px !important; /* Ajouté pour plus d'espace en haut */
    justify-content: center !important; /* Assure un centrage parfait */
  }

  .swal2-confirm,
  .swal2-cancel {
    padding: 18px 35px !important; /* Augmenté de 14px/30px à 18px/35px */
    font-size: 18px !important; /* Augmenté de 16px à 18px */
    text-transform: uppercase !important;
    font-weight: 700 !important; /* Plus gras qu'avant (600 → 700) */
    letter-spacing: 0.8px !important; /* Augmenté de 0.5px à 0.8px */
    color: white !important;
    border-radius: 6px !important; /* Arrondi légèrement augmenté */
    transition: all 0.2s ease !important;
    box-shadow: 0 3px 8px rgba(0,0,0,0.3) !important; /* Ombre plus prononcée */
    position: relative !important;
    overflow: hidden !important;
    min-width: 160px !important; /* Augmenté de 130px à 160px */
    height: 60px !important; /* Hauteur fixe ajoutée */
    line-height: 24px !important; /* Ligne plus haute pour le texte */
  }

  .swal2-confirm {
    background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary-color) 100%) !important;
    border: none !important;
  }

  .swal2-cancel {
    background: linear-gradient(135deg, var(--secondary-light) 0%, var(--secondary-color) 100%) !important;
    border: none !important;
  }

  .swal2-confirm:hover,
  .swal2-cancel:hover {
    transform: translateY(-3px) !important; /* Plus prononcé (-2px → -3px) */
    box-shadow: 0 5px 12px rgba(0,0,0,0.4) !important; /* Ombre plus intense */
    filter: brightness(110%) !important; /* Ajout de luminosité au survol */
  }

  .swal2-confirm:active,
  .swal2-cancel:active {
    transform: translateY(1px) !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2) !important;
  }

  .swal2-confirm::before,
  .swal2-cancel::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%);
    transition: all 0.6s ease;
  }

  .swal2-confirm:hover::before,
  .swal2-cancel:hover::before {
    left: 100%;
  }

  /* Style spécifique pour le bouton Valider pour le mettre plus en évidence */
  .swal2-confirm {
    box-shadow: 0 3px 10px rgba(0,150,136,0.4) !important;
  }

  .swal2-confirm:hover {
    box-shadow: 0 5px 15px rgba(0,150,136,0.6) !important;
  }

  /* Ajout d'un effet de pulsation subtil pour attirer l'attention */
  @keyframes subtlePulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.03); }
    100% { transform: scale(1); }
  }

  .swal2-confirm {
    animation: subtlePulse 2s infinite;
  }

  .swal2-confirm:hover {
    animation: none;
  }

  /* Style pour les selects */
  .form-group select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2300796B'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 24px;
    padding-right: 30px;
  }

  /* Style pour le statut de chargement */
  .command-modal-loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(3px);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .command-modal-spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  }

  .command-modal-spinner {
    width: 60px;
    height: 60px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--primary-color);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loader-text {
    font-size: 12px;
    color: var(--primary-color);
    margin-top: 10px;
    font-weight: 500;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Toasts d'alertes améliorés */
  .swal2-toast {
    background: white !important;
    box-shadow: 0 3px 10px rgba(0,0,0,0.2) !important;
    padding: 15px !important;
  }

  .swal2-toast .swal2-title {
    font-size: 14px !important;
    color: #333 !important;
  }

  /* En-tête du modal */
  .custom-modal-header {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%) !important;
    color: white !important;
  }

  /* Style pour la toolbar */
  .v-toolbar__title {
    font-size: 20px !important; /* Agrandir le titre */
    width: 100% !important; /* Prendre toute la largeur */
    text-align: center !important; /* Centrer le texte */
    margin-left: 40px !important; /* Compensation pour l'icône */
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }

    .form-group {
      margin: 5px 10px;
    }
  }
</style>
`;

function cellActualDateRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.CheckboxRenderer.apply(this, arguments);

  if (column === 1) {
    td.className = "colYellow htCenter htMiddle";
  }
}

function cellRedAnonymeRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  if (column === 2) {
    td.className = "colRed htCenter htMiddle";
  }
}

function cellGreenAnonymeRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  if (column === 2) {
    td.className = "colGreen htCenter htMiddle";
  }
}

function cellPastDateRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.CheckboxRenderer.apply(this, arguments);

  if (column === 1) {
    td.className = "colBrown htCenter htMiddle";
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "commandes",
  components: {HotTable},
  data: function () {
    return {
      lastMenuRequestTime: 0,
      sigleRestaurateur: "",
      isMobile: isMobileDevice(),
      bDisplayOK_Corinne: false,
      bDisplayOK_PointFocal: false,
      bDisplayOK_Restaurateur: false,
      bDisplayOK_RH: false,
      bDisplayOK_ASSA: false,
      bDisplayOK_TSA: false,
      namePDFile: "Détails des commandes ",
      heading: "Commandes du",
      isListMeal: false,
      disableMainBtn: false,
      dateMinDP: "",
      lastHighlitedRow: null,
      modaldc: null,
      searchName: "",
      searchNameCmd: "",
      menu2: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      toObjectCmd: [],
      timeMeal: [],
      selectDates: depthDate,
      selectDatesHeight: heightDate,
      depthVal: {
        name: "Profondeur Hier",
        value: "1"
      },
      heightVal: {
        name: "Hauteur Demain",
        value: "1"
      },
      depthValToday: {
        name: "Profondeur Aujourd'hui",
        value: "0"
      },
      heightValToday: {
        name: "Hauteur Aujourd'hui",
        value: "0"
      },
      editedItem: {
        orderDate: moment().toISOString().substr(0, 10),
        userId: "",
        timeMeal: "Déjeuner",
        reasonAbsence: "",
        startDate: moment().toISOString().substr(0, 10),
        endDate: moment().toISOString().substr(0, 10),
        absenceObservations: "",
        onGoing: "",
        restaurateur: ""
      },
      editedItemCmd: {
        orderDate: moment().toISOString().substr(0, 10),
        userId: "",
        nameMeal: "",
        timeMeal: "Déjeuner",
        reasonAbsence: "",
        startDate: moment().toISOString().substr(0, 10),
        endDate: moment().toISOString().substr(0, 10),
        absenceObservations: "",
        onGoing: "",
        restaurateur: ""
      },
      toObjectNoHeader: [],
      listMeals: [],
      timeMealtypes: ["Déjeuner", "Diner"],
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      colorCmd: "",
      file: "",
      alertCmd: false,
      textCmd: "",
      typeCmd: "",
      bYesMeal: false,
      editedIndex: -1,
      errors: [],
      errorsCmd: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true, //sessionStorage.getItem('userRole').toLowerCase() !== "RESTAURATEUR".toLowerCase(),
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"], //(sessionStorage.getItem('userRole').toLowerCase() !== "RESTAURATEUR".toLowerCase()) ? (["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"]) : null,
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            remove_row: {
              name: "Supprimer la ligne"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: this.bDisplayOK_Restaurateur,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 11, 14, 15],
          indicators: false
        },
        colHeaders: [
          "Id", "Annuler", "Matricule", "Nom", "Prénoms", "Brigade", "Shift", "N° commande", "Date commande", "Horaire repas",
          "Nom du menu", "Prix du menu", "Observations", "Date création", "Matricule créateur", "Anonyme", "Restaurant"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Annuler", width: "120px", type: "checkbox"},
          {title: "Matricule", width: "120px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénoms", width: "200px", readOnly: true},
          {title: "Brigade", width: "130px", readOnly: true},
          {title: "Shift", width: "150px", readOnly: true},
          {title: "N° commande", width: "160px", readOnly: true},
          {
            title: "Date commande",
            width: "150px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {title: "Horaire repas", width: "130px", readOnly: true},
          {title: "Nom du menu", width: "250px", readOnly: true},
          {title: "Prix du menu", width: "160px", readOnly: true},
          {title: "Observations", width: "160px"},
          {
            title: "Date de création",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true},
          {title: "Anonyme", width: "120px", type: "checkbox"},
          {title: "Restaurant", width: "120px", readOnly: true}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};
          let strDate;

          if (col === 2) {
            const cellValue = this.instance.getSourceDataAtCell(row, 2);
            let bAnonyme = this.instance.getSourceDataAtCell(row, 15);

            if (listGuess.includes(cellValue) || (bAnonyme === true)) {
              if (listGuess.includes(cellValue)) {
                cellProperties.readOnly = false;
                cellProperties.renderer = cellRedAnonymeRenderer;
              } else {
                cellProperties.readOnly = true;
                cellProperties.renderer = cellGreenAnonymeRenderer;
              }
            }
          } else if (col === 1) {
            strDate = this.instance.getSourceDataAtCell(row, 8)
            let dateOrder = moment(strDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            let dateActual = moment().format("YYYY-MM-DD")

            if (dateActual === dateOrder) {
              cellProperties.readOnly = false;
              cellProperties.renderer = cellActualDateRenderer;
            } else if (dateActual > dateOrder) {
              cellProperties.readOnly = true;
              cellProperties.renderer = cellPastDateRenderer;
            }
          }

          return cellProperties;
        }
      },
      hotSettingsCmd: {
        data: [],
        colWidths: 100,
        width: "100%",
        height: "600px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            checkThisCell: {
              name: "Sélectionner agent",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.checkThisAgent(start.row)
                }, 0);
              }
            },
            uncheckThisCell: {
              name: "Désélectionner agent",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.uncheckThisAgent(start.row)
                }, 0);
              }
            },
            /*check: {
                name: "Tout sélectionner",
                callback(key, selection, clickEvent) { // Callback for specific option
                    setTimeout(() => {
                        window.checkAllCommands()
                    }, 0);
                }
            },*/
            sp1: '---------',
            uncheck: {
              name: "Tout désélectionner",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  window.uncheckAllCommands()
                }, 0);
              }
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        autoWrapRow: true,
        stretch: "all",
        readOnly: false,
        afterFilter: this.afterFilterCmd,
        afterLoadData: this.afterLoadDataCmd,
        manualColumnResize: true,
        className: "htCenter htMiddle",
        currentRowClassName: 'rowHighlight',
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          'Id', 'Commander', 'Matricule', 'Nom', 'Prénoms', 'Brigade', 'Shift', 'Observations'
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Commander", width: "120px", type: "checkbox"},
          {title: "Matricule", width: "150px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénoms", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {title: "Shift", width: "100px", readOnly: true},
          {title: "Observations", width: "160px"}
        ]
      }
    }
  },
  created() {
    this.isCorinne()
    this.isPointFocal()
    this.isRestaurateur()
    this.isRespASSA()
    this.isRespTSA()
    this.isRH()
    this.getData()
  },
  computed: {
    computedDateFormattedMinStart() {
      return moment().format("YYYY-MM-DD").toString()
      //else return moment().add(1, 'days').format("YYYY-MM-DD").toString()
    },

    computedDateFormattedDCmd() {
      return this.formatDate(this.editedItemCmd.orderDate)
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedItem.endDate)
    },
  },
  mounted() {
    window.affectation = this.affectation;
    window.checkThisAgent = this.checkThisAgent;
    window.uncheckThisAgent = this.uncheckThisAgent;
    window.checkAllCommands = this.checkAllCommands;
    window.uncheckAllCommands = this.uncheckAllCommands;
    this.launchCommandDlg()
    this.getData()
  },
  methods: {
    // Nouvelle méthode pour afficher le modal
    showCommandModal() {
      // Create the content HTML for the form
      const modalContent = `
    ${customStyles}
    <div class="command-form">
      <!-- Zone réservée pour les alertes qui sera remplie dynamiquement -->
      <div id="modal-inline-alert"></div>
      <div class="form-row">
        <div class="form-group bg-teal">
          <label>Date commande</label>
          <input type="text" id="orderDate" class="flatpickr" placeholder="Choisir une date" readonly>
        </div>

        <div class="form-group bg-amber">
          <label>Horaire repas</label>
          <select id="timeMeal">
            ${this.timeMealtypes.map(time => `<option value="${time}">${time}</option>`).join('')}
          </select>
        </div>

        <div class="form-group bg-orange">
          <label>Nom du menu</label>
          <select id="mealName" ${this.isListMeal ? 'disabled' : ''}>
            <option value="" disabled selected>Sélectionner un menu</option>
            ${this.listMeals.map(meal => `<option value="${meal}">${meal}</option>`).join('')}
          </select>
        </div>

        <div class="form-group bg-blue">
            <label>Rechercher</label>
            <div class="search-input-container" style="position: relative; width: 100%;">
              <input type="text" id="searchCmd" placeholder="Rechercher" style="padding-right: 30px; width: 100%;">
              <button id="clearSearchBtn" style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                cursor: pointer;
                color: white;
                opacity: 0.7;
                font-size: 18px;
                display: none;
              ">×</button>
            </div>
        </div>
      </div>

      <div id="commandTableContainer"></div>
    </div>
  `;

      // Afficher le modal SweetAlert2
      Swal.fire({
        // Supprimez le titre standard
        title: '',
        html: `
      <div class="custom-modal-header" style="
        margin: -10px -10px 5px -10px;
        padding: 15px 20px;
        background: linear-gradient(135deg, #009688 0%, #00796B 100%);
        color: white;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        border-radius: 4px 4px 0 0;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        letter-spacing: 0.5px;
        position: relative;
        overflow: hidden;
      ">
        <div style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%);
          transform: skewX(-20deg);
          animation: shimmer 3s infinite;
        "></div>
        <div style="position: relative; z-index: 1;">
          <i class="v-icon material-icons" style="vertical-align: middle; margin-right: 10px; font-size: 24px;">restaurant_menu</i>
          Faites votre choix puis validez la commande
        </div>
      </div>
      ${modalContent}
      <style>
        @keyframes shimmer {
          0% { transform: translateX(-150%) skewX(-20deg); }
          100% { transform: translateX(150%) skewX(-20deg); }
        }
        /* Modifier l'espacement entre les éléments */
        .command-form {
          padding: 8px !important;
        }

        .form-row {
          margin-bottom: 10px !important;
        }

        #commandTableContainer {
          margin-top: 15px !important;
        }

        /* Ajuster l'espacement des actions en bas */
        .swal2-actions {
          margin-top: 15px !important;
          gap: 15px !important;
        }

        /* Style personnalisé pour le bouton de fermeture */
        .swal2-close {
          position: absolute !important;
          top: 25px !important;
          right: 55px !important;
          width: 36px !important;
          height: 36px !important;
          border-radius: 50% !important;
          background-color: rgba(255, 255, 255, 0.2) !important;
          backdrop-filter: blur(2px) !important;
          color: white !important;
          font-size: 20px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          transition: all 0.2s ease !important;
          border: none !important;
          outline: none !important;
          padding: 0 !important;
          opacity: 0.8 !important;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2) !important;
          transform: rotate(0deg) !important;
        }

        .swal2-close:hover {
          background-color: rgba(255, 255, 255, 0.3) !important;
          transform: rotate(90deg) !important;
          opacity: 1 !important;
          box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3) !important;
        }

        /* Important: supprimer complètement le contenu par défaut */
        .swal2-close {
          font-size: 0 !important; /* Masque le × d'origine */
        }

        /* Ajouter notre icône Material Design */
        .swal2-close::after {
          content: "close" !important;
          font-family: 'Material Icons' !important;
          font-size: 22px !important;
          font-weight: normal !important;
          font-style: normal !important;
          line-height: 1 !important;
          color: white !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
      </style>
    `,
        width: '90%',
        padding: '10px',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        confirmButtonColor: '#009688',
        cancelButtonColor: '#78909C',
        showCloseButton: true,
        customClass: {
          actions: 'swal2-actions'
        },
        // Empêcher SweetAlert de fermer automatiquement
        showLoaderOnConfirm: true,
        // Désactiver la fermeture en cliquant à l'extérieur
        allowOutsideClick: false,
        // Désactiver la fermeture en appuyant sur Échap
        allowEscapeKey: false,
        // Désactiver la fermeture en appuyant sur Entrée
        stopKeydownPropagation: false,
        keydownListenerCapture: true, // Capture les événements de touche

        preConfirm: () => {
          // Logique de validation
          if (!this.bYesMeal) {
            Swal.showValidationMessage('Veuillez sélectionner un menu valide');
            return false;
          }

          // Appel à sendCmd et retour d'une promesse pour que SweetAlert attende
          return new Promise((resolve) => {
            this.sendCmdWithCallback(resolve);
          });
        },
        // Configuration pour initialiser les éléments du formulaire
        didOpen: (modal) => {
          // Ajouter un petit délai pour s'assurer que le DOM est complètement chargé
          setTimeout(() => {
            // Initialiser Flatpickr pour la date
            try {
              const fp = flatpickr("#orderDate", {
                defaultDate: this.editedItemCmd.orderDate,
                minDate: this.computedDateFormattedMinStart,
                dateFormat: "d/m/Y",
                locale: French,
                firstDayOfWeek: 1,
                onChange: (selectedDates) => {
                  if (selectedDates && selectedDates.length > 0) {
                    this.editedItemCmd.orderDate = moment(selectedDates[0]).format('YYYY-MM-DD');
                    this.getNameMeal();
                    // Ajouter cette ligne pour rafraîchir la liste des utilisateurs disponibles
                    this.getDataCmd(); // Recharger les données utilisateurs pour la nouvelle date
                  }
                },
                // Vérifier si l'élément existe avant de manipuler ses classes
                onReady: function (dateObj, dateStr, instance) {
                  if (instance && instance.calendarContainer) {
                    instance.calendarContainer.classList.add('centered-calendar');
                  }
                }
              });

              // Vérifier si fp a été correctement initialisé
              if (fp && typeof fp.setDate === 'function') {
                fp.setDate(moment(this.editedItemCmd.orderDate).toDate());
              }
            } catch (error) {
              console.error("Erreur lors de l'initialisation du calendrier:", error);
            }

            // Configurer le sélecteur d'horaire
            const timeMealSelect = document.getElementById('timeMeal');
            timeMealSelect.value = this.editedItemCmd.timeMeal;
            timeMealSelect.addEventListener('change', () => {
              this.editedItemCmd.timeMeal = timeMealSelect.value;
              this.getNameMeal();
              // Ajouter cette ligne pour rafraîchir la liste des utilisateurs disponibles
              this.getDataCmd(); // Recharger les données utilisateurs pour le nouvel horaire
            });

            // Configurer le sélecteur de menu
            const mealNameSelect = document.getElementById('mealName');
            mealNameSelect.innerHTML = ''; // Vider d'abord les options existantes

            if (this.listMeals && this.listMeals.length > 0) {
              // Ajouter les options de menu disponibles
              this.listMeals.forEach(meal => {
                const option = document.createElement('option');
                option.value = meal;
                option.textContent = meal;
                mealNameSelect.appendChild(option);
              });

              // Sélectionner le menu actuel ou le premier
              mealNameSelect.value = this.editedItemCmd.nameMeal || this.listMeals[0];
              mealNameSelect.disabled = false;
              this.editedItemCmd.nameMeal = mealNameSelect.value;
              this.bYesMeal = true;
            } else {
              // Pas de menu disponible
              const option = document.createElement('option');
              option.value = "";
              option.textContent = "Pas de menu disponible";
              option.disabled = true;
              option.selected = true;
              mealNameSelect.appendChild(option);
              mealNameSelect.disabled = true;
              this.bYesMeal = false;
            }

            // Ajouter l'écouteur d'événements
            mealNameSelect.addEventListener('change', () => {
              this.editedItemCmd.nameMeal = mealNameSelect.value;
              // Mettre à jour l'état de bYesMeal
              this.bYesMeal = !this.isEmpty(mealNameSelect.value);
            });

            // Configurer la recherche avec l'option clearable
            const searchInput = document.getElementById('searchCmd');
            const clearButton = document.getElementById('clearSearchBtn');

            // Fonction modifiée pour vider le champ de recherche SANS recharger la page
            const clearSearch = () => {
              searchInput.value = '';
              clearButton.style.display = 'none';
              this.searchNameCmd = '';

              // Au lieu d'appeler this.getDataCmd() qui recharge toutes les données
              // Nous allons simplement réinitialiser le filtrage sur les données déjà chargées

              // Si nous utilisons la nouvelle version avec hotTableCmd
              if (this.hotTableCmd) {
                // Obtenir les données originales sans filtre
                const originalData = this.toObjectCmd.slice(1); // Ignorer l'en-tête
                // Recharger ces données dans la table
                this.hotTableCmd.loadData(originalData);
              }
              // Pour la version avec refs
              else if (this.$refs.hotTableCmd && this.$refs.hotTableCmd.hotInstance) {
                // Réinitialiser les filtres sans recharger les données du serveur
                this.$refs.hotTableCmd.hotInstance.getPlugin('filters').clearConditions();
                this.$refs.hotTableCmd.hotInstance.getPlugin('filters').filter();
              }
            };

            // Afficher le bouton de suppression quand il y a du texte
            searchInput.addEventListener('input', () => {
              this.searchNameCmd = searchInput.value;
              clearButton.style.display = searchInput.value ? 'block' : 'none';
              this.searchCmd(); // Déclencher la recherche avec le filtre
            });

            // Action du bouton de suppression - utiliser notre fonction modifiée
            clearButton.addEventListener('click', clearSearch);

            // Gérer la touche Échap
            searchInput.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') {
                clearSearch(); // Utiliser notre fonction modifiée
                e.preventDefault();
              }
            });

            // Initialiser la table Handsontable
            this.$nextTick(() => {
              const container = document.getElementById('commandTableContainer');
              if (container) {
                // Cloner les paramètres de la table existante
                const tableSettings = JSON.parse(JSON.stringify(this.hotSettingsCmd));

                // Créer une nouvelle instance
                this.hotTableCmd = new Handsontable(container, tableSettings);

                // Charger les données initiales IMMÉDIATEMENT après la création de l'instance
                this.getDataCmd();
              }
            });

            // Observer les changements de bYesMeal pour activer/désactiver le bouton
            this.$watch('bYesMeal', (newVal) => {
              const confirmButton = Swal.getConfirmButton();
              if (confirmButton) {
                confirmButton.disabled = !newVal;
                confirmButton.style.opacity = newVal ? '1' : '0.5';
              }
            });
            // ✅ AJOUTER : Appel initial à getNameMeal() pour charger les menus
            setTimeout(() => {
              this.getNameMeal();
            }, 100);

          }, 50); // Un petit délai de 50ms devrait suffire
        }
      });
    },

// Nouvelle méthode pour traiter l'envoi avec un callback
    sendCmdWithCallback(resolveCallback) {
      // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = true;

      var orderItemsList = [];
      var nameMeal = this.editedItemCmd.nameMeal;

      let day, month, year;
      day = this.getDay(this.editedItemCmd.orderDate);
      month = this.getMonth(this.editedItemCmd.orderDate);
      year = this.getYear(this.editedItemCmd.orderDate);

      var dayTmp = this.daysIntoYear(new Date(year, month - 1, day));

      var order = {
        name: dayTmp + "_" + sessionStorage.getItem("userId") + "_" + this.editedItemCmd.timeMeal,
        orderDate: moment(this.editedItemCmd.orderDate).format("YYYY-MM-DD"),
        timeMeal: this.editedItemCmd.timeMeal
      };

      var arraydata = this.hotTableCmd ? this.hotTableCmd.getData() : [];
      var length = arraydata.length;
      var realNumberSelected = 0;

      for (let i = 0; i < length; i++) {
        if (arraydata[i][1] === true) {
          orderItemsList.push({
            userId: arraydata[i][2],
            observations: arraydata[i][7],
          });
          realNumberSelected++;
        }
      }

      if (realNumberSelected === 0) {
        // Afficher un message de validation directement dans le modal principal
        Swal.showValidationMessage("Merci de sélectionner au moins une ligne avant de valider");

        // Ajouter un timer pour effacer automatiquement le message après 5 secondes
        setTimeout(() => {
          Swal.resetValidationMessage();
        }, 5000);

        // Indiquer de ne pas fermer le modal principal
        resolveCallback(false);
        return;
      }

      // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = true;

      var dataToSave = {order, orderItemsList, nameMeal};

      apiClient
          .post(`${this.$store.getters.user.baseUrl}/order/createListOrderItems/` +
              sessionStorage.getItem("userId"), dataToSave)
          .then(res => {
            // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = false;

            if (res.data.status === 200) {
              // Succès - mais on reste sur le même modal
              // Afficher un message de succès dans le modal
              const successAlert = document.createElement('div');
              successAlert.style.cssText = `
          margin: 20px auto;
          padding: 15px;
          border-radius: 5px;
          background-color: #4CAF50;
          color: white;
          text-align: center;
          font-weight: bold;
          max-width: 80%;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
          animation: fadeIn 0.3s ease;
          position: relative;
        `;

              successAlert.innerHTML = `
          <div style="display: flex; align-items: center; justify-content: center;">
            <i class="v-icon material-icons" style="margin-right: 10px;">check_circle</i>
            <span>${res.data.message}</span>
          </div>
          <div style="margin-top: 10px; font-size: 90%;">
            Les commandes ont été enregistrées avec succès.
          </div>
        `;

              // Insérer l'alerte au début du formulaire
              const form = document.querySelector('.command-form');
              if (form) {
                // Supprimer d'abord toute alerte existante
                const existingAlert = document.querySelector('.success-alert');
                if (existingAlert) {
                  existingAlert.remove();
                }

                successAlert.className = 'success-alert';
                form.insertBefore(successAlert, form.firstChild);
              }

              // Désélectionner toutes les lignes qui ont été envoyées
              if (this.hotTableCmd) {
                for (let i = 0; i < length; i++) {
                  if (arraydata[i][1] === true) {
                    this.hotTableCmd.setDataAtCell(i, 1, false);
                  }
                }
              }

              // Au lieu de recharger toute la page, rechargez uniquement
              // les données de Handsontable dans le modal
              this.getDataCmd();

              // Masquer l'alerte après 5 secondes
              setTimeout(() => {
                const alertToRemove = document.querySelector('.success-alert');
                if (alertToRemove) {
                  alertToRemove.style.animation = 'fadeOut 0.5s ease';
                  setTimeout(() => {
                    alertToRemove.remove();
                  }, 500);
                }
              }, 5000);

              // ✅ AJOUTER JUSTE CETTE LIGNE :
              setTimeout(() => {
                this.refresh(); // Mettre à jour la table principale en arrière-plan
              }, 300);

              // Ne pas fermer le modal
              resolveCallback(false);
            } else {
              // Erreur - on affiche le message d'erreur sans fermer le modal
              Swal.showValidationMessage(res.data.message);

              // Ajouter un timer pour effacer automatiquement le message après 5 secondes
              setTimeout(() => {
                Swal.resetValidationMessage();
              }, 5000);

              // Ne pas fermer le modal
              resolveCallback(false);
            }
          })
          .catch(error => {
            // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = false;

            Swal.showValidationMessage("Une erreur s'est produite lors de l'envoi des commandes");

            // Ajouter un timer pour effacer automatiquement le message après 5 secondes
            setTimeout(() => {
              Swal.resetValidationMessage();
            }, 5000);

            // Ne pas fermer le modal
            resolveCallback(false);
          });
    },
    launchCommandDlg() {
      if (this.bDisplayOK_PointFocal) {
        this.dialog = true
        this.initCmd()
      }
    },
    isRespASSA() {
      this.bDisplayOK_ASSA = sessionStorage.getItem('userRole').toLowerCase() === "RESPONSABLE ADMINISTRATIF".toLowerCase() || sessionStorage.getItem('userRole').toLowerCase() === "COORDINATEUR ADMINISTRATIF ASSA".toLowerCase()
    },
    isRespTSA() {
      this.bDisplayOK_TSA = sessionStorage.getItem('userRole').toLowerCase() === "DIRECTEUR D'EXPLOITATION ADJOINTE / COO".toLowerCase() || sessionStorage.getItem('userRole').toLowerCase() === "COORD PRINCIPAL ADJOINT".toLowerCase()
          || sessionStorage.getItem('userRole').toLowerCase() === "ASSISTANT ADMINISTRATIF".toLowerCase()
    },
    isCorinne() {
      this.bDisplayOK_Corinne = (sessionStorage.getItem("userId") === "18106") || (sessionStorage.getItem("userId").toLowerCase() === "admin")
    },
    isPointFocal() {
      this.bDisplayOK_PointFocal = sessionStorage.getItem('userRole').toLowerCase() === "POINT FOCAL RESTO".toLowerCase() ||
          sessionStorage.getItem('userRole').toLowerCase() === "CHEF DE POSTE".toLowerCase()
    },
    isRestaurateur() {
      this.bDisplayOK_Restaurateur = sessionStorage.getItem('userRole').toLowerCase() === "RESTAURATEUR".toLowerCase()

      if (this.bDisplayOK_Restaurateur) {
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/userInfos/` + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              let newObj = response.data.data;
              this.sigleRestaurateur = newObj.accountLastname
            })
            .catch(error => {
              console.log("Commandes")
            });
      }
    },
    isRH() {
      this.bDisplayOK_RH = sessionStorage.getItem('userRole').toLowerCase().includes("RH".toLowerCase())
    },
    generatePDF() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/timeserver`
          )
          .then(response => {
            let newObj = response.data.datas;

            let dtHrPrint = moment().format("DD-MM-YYYY HH:mm:ss")

            let timeSplit = newObj.split(' ');

            let timeActualServ = moment(timeSplit[1], 'HH:mm:ss');
            let timeRef = moment('11:00:00', 'HH:mm:ss');

            if (!this.bDisplayOK_Corinne && timeActualServ.isBefore(timeRef)) {
              this.text = "On ne peut imprimer les commandes du jour qu'à partir de 11h";
              this.showAlert('warning')
              this.loading = false
              return;
            }

            if (!this.isEmpty(newObj)) {
              if (this.bDisplayOK_Restaurateur) {
                this.generatePDFShort()
              } else {
                let imgBase64TSA = ""
                let imgBase64Maay = ""
                let imgBase64Ndellice = ""

                imageToBase64(require('../../../assets/Logo_TSA_fine.png')) // Image URL
                    .then(
                        (response) => {
                          imageToBase64(require('../../../assets/logo_maay.png')) // Image URL
                              .then(
                                  (responseMaay) => {
                                    imageToBase64(require('../../../assets/logo_ndellices.jpg')) // Image URL
                                        .then(
                                            (responseNdellice) => {
                                              this.loading = true

                                              imgBase64TSA = response
                                              imgBase64Maay = responseMaay
                                              imgBase64Ndellice = responseNdellice

                                              if (this.toObject.length <= 1) {
                                                this.text = "Il n'y a aucune commande à télécharger.";
                                                this.showAlert('warning')
                                                this.loading = false
                                                return;
                                              }

                                              let listOrdersDates
                                              let listRestaurateurs
                                              let listTimeMeal = ["Déjeuner", "Diner"]

                                              listOrdersDates = this.getListOrdersDates(this.toObject)
                                              listRestaurateurs = this.getListRestaurateurs(this.toObject)
                                              let listRestaurateursImg = []

                                              for (let g = 0; g < listRestaurateurs.length; g++) {
                                                if (listRestaurateurs[g].toLowerCase().localeCompare("MAAY FOOD".toLowerCase()) === 0)
                                                  listRestaurateursImg.push(imgBase64Maay)
                                                else if (listRestaurateurs[g].toLowerCase().localeCompare("NDELLICE".toLowerCase()) === 0)
                                                  listRestaurateursImg.push(imgBase64Ndellice)
                                              }

                                              listOrdersDates.shift()

                                              String.prototype.capitalize = function (allWords) {
                                                return (allWords) ? // if all words
                                                    this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                                                    this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
                                              }

                                              for (let h = 0; h < listRestaurateursImg.length; h++) {
                                                //console.log("Restaurateur " + listRestaurateurs[h])
                                                for (let orderDate of listOrdersDates) {
                                                  //console.log("Date " + orderDate)
                                                  for (let timeMeal of listTimeMeal) {
                                                    //console.log("TimeMeal " + timeMeal)

                                                    let doc = new jsPDF({
                                                      orientation: "portrait",
                                                      unit: "in",
                                                      format: "letter"
                                                    });

                                                    let listing = "Listing global"
                                                    let brgNameCurrent = ""
                                                    let currentDate = ""

                                                    let refCurrent = ""
                                                    let refOld = ""
                                                    let indi = 0
                                                    let indj = 0

                                                    let nbrTotalCommands = 0
                                                    let nbrSubTotalCommands = 0
                                                    let subTotalCommands = 0
                                                    let totalCommands = 0
                                                    let nbrCommandsByBRG = 0

                                                    let toObjectTmp = []
                                                    let toObjectTmp2 = []
                                                    let toObjectTmp3 = []

                                                    //Array.prototype.push.apply(toObjectTmp, this.toObject);
                                                    toObjectTmp = this.getOrderLinesByResto(this.toObject, listRestaurateurs, h)
                                                    toObjectTmp2 = this.getOrdersByDate(toObjectTmp, orderDate)
                                                    toObjectTmp3 = this.keepOnlyThisTime(toObjectTmp2, timeMeal)

                                                    toObjectTmp = toObjectTmp3

                                                    nbrTotalCommands = toObjectTmp.length
                                                    totalCommands = this.getTotalCommands(toObjectTmp)

                                                    for (indi = 0; indi < toObjectTmp.length; indi++) {
                                                      let finalTab = []

                                                      currentDate = toObjectTmp[indi][8]
                                                      //brgNameCurrent = toObjectTmp[indi][5].toLowerCase().includes('assa')?'PRESTA':(toObjectTmp[indi][5].toLowerCase().includes('tsa')?'TSA':'DIRECTION')
                                                      brgNameCurrent = toObjectTmp[indi][5]

                                                      nbrSubTotalCommands = 0;
                                                      subTotalCommands = 0;
                                                      for (indj = indi; indj < toObjectTmp.length; indj++) {
                                                        ++nbrSubTotalCommands;
                                                        subTotalCommands += toObjectTmp[indj][11]

                                                        refOld = refCurrent;
                                                        refCurrent = toObjectTmp[indj][8] + " " + toObjectTmp[indj][5]

                                                        if (refOld === "") { // Le 1er
                                                          finalTab.push(toObjectTmp[indj]);
                                                        } else {
                                                          if (refOld !== refCurrent) {
                                                            break;
                                                          }
                                                          finalTab.push(toObjectTmp[indj]);
                                                        }
                                                      }

                                                      indi = indj - 1;

                                                      doc.autoTable({
                                                        head: this.headRowsListing(listing.toUpperCase(), nbrTotalCommands, totalCommands.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.')),
                                                        headStyles: {
                                                          fillColor: [241, 196, 15],
                                                          fontSize: 15,
                                                          valign: 'middle'
                                                        },
                                                        footStyles: {
                                                          fillColor: [241, 196, 15],
                                                          fontSize: 12,
                                                          halign: 'right',
                                                          valign: 'middle'
                                                        },
                                                        lineWidth: 1,
                                                        tableLineColor: [241, 196, 15], //choose RGB
                                                        tableLineWidth: 0.02, //table border width
                                                        margin: {left: 0.75, top: 1.90, right: 0.75},
                                                        pageBreak: 'always', //'avoid'|'always'

                                                        didParseCell: function (data) {
                                                          if ((data.row.section === 'head') && (data.cell.text[0] === listing.toUpperCase())) {
                                                            data.cell.styles.halign = 'center'
                                                          }

                                                          if ((data.row.section === 'head') && (data.cell.text[0] === ("Commandes : " + nbrTotalCommands))) {
                                                            data.cell.styles.halign = 'center'
                                                            data.cell.styles.minCellWidth = 0.9
                                                          }

                                                          if ((data.row.section === 'head') && (data.cell.text[0] === ("Total : " + totalCommands.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.') + " CFA"))) {
                                                            data.cell.styles.halign = 'center'
                                                            data.cell.styles.minCellWidth = 0.9
                                                          }
                                                        },

                                                        didDrawPage: function (data) {
                                                          // Header
                                                          //https://rawgit.com/MrRio/jsPDF/master/fontconverter/fontconverter.html pour convertir le font ttf en js.
                                                          doc
                                                              .addImage(imgBase64TSA, 'PNG', 0.75, 0.75, 1.1, 1)
                                                              .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)
                                                              .setFont("MotionPicture", 'normal')
                                                              .setFontSize(50)
                                                              .setTextColor(25, 52, 101)
                                                              .text("Restauration", 3.20, 1.20);

                                                          doc
                                                              .setFont("times", "bolditalic")
                                                              .setFontSize(15)
                                                              .setTextColor(19, 39, 76)
                                                              .text(
                                                                  "Date des commandes " + orderDate,
                                                                  4.38,
                                                                  1.60,
                                                                  {align: "center"}
                                                              )

                                                          doc
                                                              .addImage(listRestaurateursImg[h], 'PNG', 6.50, 0.85, 1.4, 0.90)
                                                              .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)

                                                          // create a line under heading
                                                          doc.setDrawColor(19, 39, 76);
                                                          doc.setLineWidth(0.03).line(0.75, 1.80, 7.75, 1.80);
                                                          // Using autoTable plugin
                                                        },
                                                      });

                                                      nbrCommandsByBRG = this.getNbrCommandsByBRG(toObjectTmp, currentDate, brgNameCurrent)
                                                      subTotalCommands = this.getSubTotalCommandsByBRG(toObjectTmp, currentDate, brgNameCurrent)

                                                      doc.autoTable({
                                                        startY: doc.lastAutoTable.finalY + 0.05,
                                                        head: this.headRowsBRG(brgNameCurrent.toUpperCase(), nbrCommandsByBRG, subTotalCommands.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.')),
                                                        headStyles: {
                                                          fillColor: [74, 96, 117],
                                                          fontSize: 12,
                                                          halign: 'center',
                                                          valign: 'middle'
                                                        },
                                                        lineWidth: 1,
                                                        tableLineColor: [74, 96, 117], //choose RGB
                                                        tableLineWidth: 0.02, //table border width
                                                        margin: {left: 0.85, right: 0.85},

                                                        didParseCell: function (data) {
                                                          if ((data.row.section === 'head') && (data.cell.text[0] === ("Groupe " + brgNameCurrent.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.')))) {
                                                            data.cell.styles.halign = 'center'
                                                          }

                                                          if ((data.row.section === 'head') && (data.cell.text[0] === ("Commandes : " + nbrCommandsByBRG))) {
                                                            data.cell.styles.halign = 'center'
                                                            data.cell.styles.minCellWidth = 0.9
                                                          }

                                                          if ((data.row.section === 'head') && (data.cell.text[0] === ("Total : " + subTotalCommands.toLocaleString() + " CFA"))) {
                                                            data.cell.styles.halign = 'center'
                                                            data.cell.styles.minCellWidth = 0.9
                                                          }
                                                        },
                                                      });

                                                      let tabTCommands = []
                                                      let currentDateByBRG = ""
                                                      let currentDateByBRGNext = ""
                                                      let incrSaut
                                                      let b1stSaut = 1;
                                                      let bFin = false;

                                                      for (var indk = 0; indk < finalTab.length; indk++) {
                                                        currentDateByBRG = finalTab[indk][8]

                                                        if (indk === (finalTab.length - 1)) {
                                                          bFin = true
                                                          currentDateByBRGNext = finalTab[indk][8]
                                                        } else {
                                                          currentDateByBRGNext = finalTab[indk + 1][8]
                                                        }

                                                        if ((currentDateByBRG === currentDateByBRGNext) && (bFin === false)) {
                                                          tabTCommands.push([finalTab[indk][2], (finalTab[indk][3]).toUpperCase() + " " + finalTab[indk][4].toLowerCase().capitalize(true), finalTab[indk][10], finalTab[indk][11].toString().replace(/(.)(?=(\d{3})+$)/g, '$1.'), finalTab[indk][9]]);
                                                        } else {
                                                          tabTCommands.push([finalTab[indk][2], (finalTab[indk][3]).toUpperCase() + " " + finalTab[indk][4].toLowerCase().capitalize(true), finalTab[indk][10], finalTab[indk][11].toString().replace(/(.)(?=(\d{3})+$)/g, '$1.'), finalTab[indk][9]]);

                                                          if ((currentDateByBRG !== currentDateByBRGNext) || (bFin === true)) {
                                                            if (b1stSaut === 1) {
                                                              incrSaut = 0
                                                              b1stSaut = 0
                                                            } else {
                                                              incrSaut = 0.2
                                                            }

                                                            doc.autoTable({
                                                              startY: doc.lastAutoTable.finalY + 0.03 + incrSaut,
                                                              head: this.headRowsDate(currentDateByBRG),
                                                              headStyles: {
                                                                fillColor: [155, 89, 182],
                                                                fontSize: 10
                                                              },
                                                              margin: {left: 0.85, right: 0.85},
                                                              didParseCell: function (data) {
                                                                if ((data.row.section === 'head') && (data.cell.text[0] === ('DATE :            ' + currentDateByBRG))) {
                                                                  data.cell.styles.halign = 'left'
                                                                  data.cell.styles.minCellWidth = 1
                                                                }
                                                              },
                                                            });

                                                            if (this.bDisplayOK_Corinne) {
                                                              doc.autoTable({
                                                                startY: doc.lastAutoTable.finalY + 0.03,
                                                                head: this.bodyHead(),
                                                                body: this.bodyRows(tabTCommands),
                                                                headStyles: {
                                                                  fontSize: 10,
                                                                },
                                                                bodyStyles: {
                                                                  fontSize: 10
                                                                },
                                                                margin: {left: 0.85, right: 0.85},
                                                                columnStyles: {
                                                                  0: {cellWidth: 0.8},
                                                                  1: {cellWidth: 2.3},
                                                                  2: {cellWidth: 2.4},
                                                                  3: {cellWidth: 0.5},
                                                                  4: {cellWidth: 0.8, halign: 'center'}
                                                                },
                                                                didParseCell: function (data) {
                                                                  if ((data.row.section === 'head') && (data.cell.text[0] === ('Horaire'))) {
                                                                    data.cell.styles.halign = 'center'
                                                                  }
                                                                },
                                                              });
                                                            } else {
                                                              doc.autoTable({
                                                                startY: doc.lastAutoTable.finalY + 0.03,
                                                                head: this.bodyHead(),
                                                                body: this.bodyRows(tabTCommands),
                                                                headStyles: {
                                                                  fontSize: 10,
                                                                },
                                                                bodyStyles: {
                                                                  fontSize: 10
                                                                },
                                                                margin: {left: 0.85, right: 0.85},
                                                                columnStyles: {
                                                                  0: {cellWidth: 0.8},
                                                                  1: {cellWidth: 2.3},
                                                                  2: {cellWidth: 2.9},
                                                                  3: {cellWidth: 0.8, halign: 'center'}
                                                                },
                                                                didParseCell: function (data) {
                                                                  if ((data.row.section === 'head') && (data.cell.text[0] === ('Horaire'))) {
                                                                    data.cell.styles.halign = 'center'
                                                                  }
                                                                },
                                                              });
                                                            }

                                                            tabTCommands = []
                                                          }
                                                        }
                                                      }

                                                      if (indi === (toObjectTmp.length - 1)) {
                                                        // PAGE NUMBERING
                                                        // Add Page number at bottom-right
                                                        // Get the number of pages
                                                        const pageCount = doc.internal.getNumberOfPages();

                                                        // For each page, print the page number and the total pages
                                                        for (let i = 1; i <= pageCount; i++) {
                                                          // Go to page i
                                                          doc.setPage(i);
                                                          //Print Page 1 of 4 for example  // Creating footer and saving file
                                                          this.footPage(doc, dtHrPrint)
                                                          doc
                                                              .setTextColor(25, 52, 101)
                                                              .text("Page " + String(i - 1) + " sur " + String(pageCount - 1), 7.7, doc.internal.pageSize.height - 0.5, {align: "right"});
                                                        }

                                                        doc.deletePage(1)
                                                        doc.save(`${listRestaurateurs[h]} - ${this.heading} ${orderDate} ${timeMeal}.pdf`);

                                                        doc = new jsPDF({
                                                          orientation: "portrait",
                                                          unit: "in",
                                                          format: "letter"
                                                        });
                                                      }
                                                    }
                                                  }
                                                }
                                              }

                                              this.loading = false
                                            }
                                        )
                                        .catch(
                                            (error) => {
                                              console.log(error); // Logs an error if there was one
                                            }
                                        )
                                  }
                              )
                              .catch(
                                  (error) => {
                                    console.log(error); // Logs an error if there was one
                                    this.loading = false
                                  }
                              )
                        }
                    )
                    .catch(
                        (error) => {
                          console.log(error); // Logs an error if there was one
                          this.loading = false
                        }
                    )

                this.generatePDFShort()
              }
            }
          })
          .catch(() => {
            this.loading = false
          });
    },
    generatePDFShort() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/timeserver`
          )
          .then(response => {
            let newObj = response.data.datas;

            if (!this.isEmpty(newObj)) {
              let dtHrPrint = moment().format("DD-MM-YYYY HH:mm:ss")

              let timeSplit = newObj.split(' ');

              let timeActualServ = moment(timeSplit[1], 'HH:mm:ss');
              let timeRef = moment('11:00:00', 'HH:mm:ss');

              if (!this.bDisplayOK_Corinne && timeActualServ.isBefore(timeRef)) {
                this.text = "On ne peut imprimer les commandes du jour qu'à partir de 11h";
                this.showAlert('warning')
                this.loading = false
                return;
              }

              let imgBase64TSA = ""
              let imgBase64Maay = ""
              let imgBase64Ndellice = ""

              imageToBase64(require('../../../assets/Logo_TSA_fine.png')) // Image URL
                  .then(
                      (response) => {
                        imageToBase64(require('../../../assets/logo_maay.png')) // Image URL
                            .then(
                                (responseMaay) => {
                                  imageToBase64(require('../../../assets/logo_ndellices.jpg')) // Image URL
                                      .then(
                                          (responseNdellice) => {
                                            this.loading = true

                                            imgBase64TSA = response
                                            imgBase64Maay = responseMaay
                                            imgBase64Ndellice = responseNdellice

                                            if (this.toObject.length <= 1) {
                                              this.text = "Il n'y a aucune commande à télécharger.";
                                              this.showAlert('warning')
                                              this.loading = false
                                              return;
                                            }

                                            let listOrdersDates
                                            let listRestaurateurs
                                            let listTimeMeal = ["Déjeuner", "Diner"]

                                            listOrdersDates = this.getListOrdersDates(this.toObject)
                                            listRestaurateurs = this.getListRestaurateurs(this.toObject)
                                            let listRestaurateursImg = []

                                            for (let g = 0; g < listRestaurateurs.length; g++) {
                                              if (listRestaurateurs[g].toLowerCase().localeCompare("MAAY FOOD".toLowerCase()) === 0)
                                                listRestaurateursImg.push(imgBase64Maay)
                                              else if (listRestaurateurs[g].toLowerCase().localeCompare("NDELLICE".toLowerCase()) === 0)
                                                listRestaurateursImg.push(imgBase64Ndellice)
                                            }

                                            listOrdersDates.shift()

                                            String.prototype.capitalize = function (allWords) {
                                              return (allWords) ? // if all words
                                                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                                                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
                                            }

                                            for (let h = 0; h < listRestaurateursImg.length; h++) {
                                              //console.log("Restaurateur " + listRestaurateurs[h])
                                              for (let orderDate of listOrdersDates) {
                                                //console.log("Date " + orderDate)
                                                for (let timeMeal of listTimeMeal) {
                                                  //console.log("TimeMeal " + timeMeal)

                                                  let doc = new jsPDF({
                                                    orientation: "portrait",
                                                    unit: "in",
                                                    format: "letter"
                                                  });

                                                  let listing = "Listing global"
                                                  let indi = 0
                                                  let nbrTotalCommands = 0
                                                  let totalCommands = 0

                                                  let toObjectTmp = []
                                                  let toObjectTmp2 = []
                                                  let toObjectTmp3 = []

                                                  toObjectTmp = this.getOrderLinesByResto(this.toObject, listRestaurateurs, h)
                                                  toObjectTmp2 = this.getOrdersByDate(toObjectTmp, orderDate)
                                                  toObjectTmp3 = this.keepOnlyThisTime(toObjectTmp2, timeMeal)

                                                  toObjectTmp = toObjectTmp3

                                                  nbrTotalCommands = toObjectTmp.length
                                                  totalCommands = this.getTotalCommands(toObjectTmp)

                                                  doc.autoTable({
                                                    head: this.headRowsListingShort(listing.toUpperCase(), nbrTotalCommands, totalCommands.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.'), timeMeal.toUpperCase()),
                                                    headStyles: {
                                                      fillColor: [255, 255, 255],
                                                      fontSize: 15,
                                                      valign: 'middle',
                                                      textColor: [0, 0, 0]
                                                    },
                                                    footStyles: {
                                                      fillColor: [0, 0, 0],
                                                      fontSize: 12,
                                                      halign: 'right',
                                                      valign: 'middle'
                                                    },
                                                    lineWidth: 1,
                                                    tableLineColor: [0, 0, 0], //choose RGB
                                                    tableLineWidth: 0.02, //table border width
                                                    margin: {left: 0.75, top: 1.90, right: 0.75},
                                                    pageBreak: 'always', //'avoid'|'always'

                                                    didParseCell: function (data) {
                                                      if ((data.row.section === 'head') && (data.cell.text[0] === listing.toUpperCase())) {
                                                        data.cell.styles.halign = 'center'
                                                      }

                                                      if ((data.row.section === 'head') && (data.cell.text[0] === ("Commandes : " + String(nbrTotalCommands).padStart(3, ' ')))) {
                                                        data.cell.styles.halign = 'center'
                                                        data.cell.styles.minCellWidth = 0.9
                                                      }

                                                      if ((data.row.section === 'head') && (data.cell.text[0] === ("Total : " + totalCommands.toString().replace(/(.)(?=(\d{3})+$)/g, '$1.') + " CFA"))) {
                                                        data.cell.styles.halign = 'center'
                                                        data.cell.styles.minCellWidth = 0.9
                                                      }
                                                    },

                                                    didDrawPage: function (data) {
                                                      // Header
                                                      //https://rawgit.com/MrRio/jsPDF/master/fontconverter/fontconverter.html pour convertir le font ttf en js.
                                                      doc
                                                          .addImage(imgBase64TSA, 'PNG', 0.75, 0.75, 1.1, 1)
                                                          .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)
                                                          .setFont("MotionPicture", 'normal')
                                                          .setFontSize(50)
                                                          .setTextColor(25, 52, 101)
                                                          .text("Restauration", 3.20, 1.20);

                                                      doc
                                                          .setFont("times", "bolditalic")
                                                          .setFontSize(15)
                                                          .setTextColor(25, 52, 101)
                                                          .text(
                                                              "Date des commandes " + orderDate,
                                                              4.38,
                                                              1.60,
                                                              {align: "center"}
                                                          )

                                                      doc
                                                          .addImage(listRestaurateursImg[h], 'PNG', 6.50, 0.85, 1.4, 0.90)
                                                          .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)

                                                      // create a line under heading
                                                      doc.setDrawColor(0, 0, 0);
                                                      doc.setLineWidth(0.03).line(0.75, 1.80, 7.75, 1.80);
                                                      // Using autoTable plugin
                                                    },
                                                  });

                                                  const listPlats = [];

                                                  let s2;
                                                  let position;
                                                  toObjectTmp.forEach((item) => {
                                                    position = item[10].search("#")

                                                    if (position !== -1) {
                                                      s2 = item[10].substring(0, position - 1);
                                                    } else {
                                                      s2 = item[10];
                                                    }

                                                    listPlats.push(s2)
                                                  })

                                                  const counter = {};
                                                  for (let ele of listPlats) {
                                                    if (counter[ele]) {
                                                      counter[ele] += 1;
                                                    } else {
                                                      counter[ele] = 1;
                                                    }
                                                  }

                                                  let listPlatsTmp = Object.keys(counter)
                                                  let nPlats = Object.keys(counter).length

                                                  let indPlat = 0
                                                  for (indi = 0; indi < nPlats; indi++) {
                                                    let nomPlat = listPlatsTmp[indPlat++]
                                                    let nbrPlats = counter[nomPlat]

                                                    doc.autoTable({
                                                      startY: doc.lastAutoTable.finalY + 0.05,
                                                      head: this.headRowsMenuShort(nomPlat.toString(), nbrPlats),
                                                      headStyles: {
                                                        fillColor: [255, 255, 255],
                                                        fontSize: 12,
                                                        halign: 'left',
                                                        valign: 'middle',
                                                        textColor: [0, 0, 0]
                                                      },
                                                      lineWidth: 1,
                                                      tableLineColor: [0, 0, 0], //choose RGB
                                                      tableLineWidth: 0.02, //table border width
                                                      margin: {left: 0.85, right: 0.85},

                                                      didParseCell: function (data) {
                                                        if ((data.row.section === 'head') && (data.cell.text[0] === (nomPlat.toString()))) {
                                                          data.cell.styles.halign = 'left'
                                                        }

                                                        if ((data.row.section === 'head') && (data.cell.text[0] === ("Nombre : " + String(nbrPlats).padStart(3, ' ')))) {
                                                          data.cell.styles.halign = 'right'
                                                          data.cell.styles.minCellWidth = 0.9
                                                        }
                                                      },
                                                    });

                                                    if (indi === (nPlats - 1)) {
                                                      // PAGE NUMBERING
                                                      // Add Page number at bottom-right
                                                      // Get the number of pages
                                                      const pageCount = doc.internal.getNumberOfPages();

                                                      // For each page, print the page number and the total pages
                                                      for (let i = 1; i <= pageCount; i++) {
                                                        // Go to page i
                                                        doc.setPage(i);
                                                        //Print Page 1 of 4 for example  // Creating footer and saving file
                                                        this.footPage(doc, dtHrPrint)
                                                        doc
                                                            .setTextColor(25, 52, 101)
                                                            .text("Page " + String(i - 1) + " sur " + String(pageCount - 1), 7.7, doc.internal.pageSize.height - 0.5, {align: "right"});
                                                      }

                                                      doc.deletePage(1)
                                                      doc.save(`${listRestaurateurs[h]} - ${this.heading} ${orderDate} ${timeMeal} - Résumé.pdf`);

                                                      doc = new jsPDF({
                                                        orientation: "portrait",
                                                        unit: "in",
                                                        format: "letter"
                                                      });
                                                    }
                                                  }
                                                }
                                              }
                                            }

                                            this.loading = false
                                          }
                                      )
                                      .catch(
                                          (error) => {
                                            console.log(error); // Logs an error if there was one
                                            this.loading = false
                                          }
                                      )
                                }
                            )
                            .catch(
                                (error) => {
                                  console.log(error); // Logs an error if there was one
                                  this.loading = false
                                }
                            )
                      }
                  )
                  .catch(
                      (error) => {
                        console.log(error); // Logs an error if there was one
                        this.loading = false
                      }
                  )
            }
          })
          .catch(() => {
            this.loading = false
          });
    },
    bodyMessages(result) {
      var body = []
      for (var j = 0; j < result.length; j++) {
        body.push({
          name: result[j],
        })
      }
      return body
    },
    headRowsMessages() {
      return [
        {name: "Messages"},
      ]
    },
    headRowsListing(brgName, size, total) {
      if (this.bDisplayOK_Corinne) {
        return [
          {name: brgName, size: "Commandes : " + size, total: "Total : " + total + " CFA"},
        ]
      } else {
        return [
          {name: brgName, size: "Commandes : " + size},
        ]
      }
    },
    headRowsListingShort(brgName, size, total, timeMeal) {
      if (this.bDisplayOK_Corinne) {
        return [
          {
            name: brgName,
            size: "Commandes : " + String(size).padStart(3, ' '),
            total: "Total : " + total + " CFA",
            repas: timeMeal
          },
        ]
      } else {
        return [
          {name: brgName, size: "Commandes : " + String(size).padStart(3, ' '), repas: timeMeal},
        ]
      }
    },
    formatStringSize(size) {
      let ret = String(size).padStart(3, ' ')
      return ret;
    },
    headRowsDate(date) {
      return [
        {name: 'DATE :         ' + date},
      ]
    },
    bodyHead() {
      if (this.bDisplayOK_Corinne) {
        return [
          {matricule: 'Matricule', name: 'Nom agent', menu: 'Menu', prix: 'Prix', horaire: 'Horaire'},
        ]
      } else {
        return [
          {matricule: 'Matricule', name: 'Nom agent', menu: 'Menu', horaire: 'Horaire'},
        ]
      }
    },
    bodyRows(tabObject) {
      var body = []
      var j
      let menuTmp
      let position
      let menuFinal

      if (this.bDisplayOK_Corinne) {
        for (j = 0; j < tabObject.length; j++) {
          menuTmp = tabObject[j][2]
          position = menuTmp.search("#")

          if (position !== -1) {
            menuFinal = menuTmp.substring(0, position - 1);
          } else {
            menuFinal = menuTmp;
          }

          body.push({
            matricule: tabObject[j][0],
            name: tabObject[j][1],
            menu: menuFinal,
            prix: tabObject[j][3],
            horaire: tabObject[j][4],
          })
        }
      } else {
        for (j = 0; j < tabObject.length; j++) {
          menuTmp = tabObject[j][2]
          position = menuTmp.search("#")

          if (position !== -1) {
            menuFinal = menuTmp.substring(0, position - 1);
          } else {
            menuFinal = menuTmp;
          }

          body.push({
            matricule: tabObject[j][0],
            name: tabObject[j][1],
            menu: menuFinal,
            horaire: tabObject[j][4],
          })
        }
      }

      return body
    },
    footPage(doc, dtHrPrint) {
      // Creating footer and saving file
      doc
          .setFont("times", "italic")
          .setFontSize(11)
          .setTextColor(25, 52, 101)
          .text(
              "Sens NumeriK - (TSA / Aéroport AIBD) - Document confidentiel    *    (" + dtHrPrint + ")",
              0.75,
              doc.internal.pageSize.height - 0.5
          )
    },
    headRowsBRG(brgName, size, subTotalCommands) {
      if (this.bDisplayOK_Corinne) {
        return [
          {
            name: "Groupe " + brgName,
            size: "Commandes : " + size,
            total: "Total : " + subTotalCommands + " CFA"
          },
        ]
      } else {
        return [
          {
            name: "Groupe " + brgName,
            size: "Commandes : " + size
          },
        ]
      }
    },
    headRowsMenuShort(brgName, size) {
      return [
        {
          name: brgName,
          size: "Nombre : " + String(size).padStart(3, ' ')
        },
      ]
    },
    getNbrCommandsByBRG(toObjectTmp, currentDate, brgNameCurrent) {
      let nbr = 0
      for (let i = 0; i < toObjectTmp.length; i++) {
        if ((toObjectTmp[i][8] === currentDate) && (toObjectTmp[i][5] === brgNameCurrent)) {
          ++nbr;
        }
      }

      return nbr;
    },
    getSubTotalCommandsByBRG(toObjectTmp, currentDate, brgNameCurrent) {
      let total = 0
      for (let i = 0; i < toObjectTmp.length; i++) {
        if ((toObjectTmp[i][8] === currentDate) && (toObjectTmp[i][5] === brgNameCurrent)) {
          total += parseInt(toObjectTmp[i][11], 10)
        }
      }

      return total;
    },
    getListOrdersDates(tab) {
      const listOrdersDatesTmp = []

      for (var i = 0; i < tab.length; i++) {
        if ((listOrdersDatesTmp.length === 0) || !listOrdersDatesTmp.includes(tab[i][8])) {
          listOrdersDatesTmp.push(tab[i][8])
        }
      }

      return listOrdersDatesTmp;
    },
    getListRestaurateurs(tab) {
      let listRestaurateursTmp = []

      for (let i = 0; i < tab.length; i++) {
        if (i !== 0)
          listRestaurateursTmp.push(tab[i][16])
      }

      return [...new Set(listRestaurateursTmp)];
    },
    getOrdersByDate(tab, orderDate) {
      const listOrdersByDateTmp = []

      for (var i = 0; i < tab.length; i++) {
        if (tab[i][8] === orderDate) {
          listOrdersByDateTmp.push(tab[i])
        }
      }

      return listOrdersByDateTmp;
    },
    getOrderLinesByResto(tab, listResto, h) {
      const linesByRestoTmp = []

      for (var i = 0; i < tab.length; i++) {
        if (tab[i][16] === listResto[h]) {
          linesByRestoTmp.push(tab[i])
        }
      }

      return linesByRestoTmp;
    },
    getTotalCommands(tab) {
      let total = 0

      for (var i = 0; i < tab.length; i++) {
        total += parseInt(tab[i][11], 10)
      }

      return total;
    },
    keepOnlyThisTime(tab, horaire) {
      let total = 0
      const tabFinal = []

      for (var i = 0; i < tab.length; i++) {
        if (tab[i][9] === horaire) {
          tabFinal[total++] = tab[i]
        }
      }

      return tabFinal;
    },
    checkThisAgent(row) {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      this.$refs.hotTableCmd.hotInstance.setDataAtCell(row, 1, true)

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    uncheckThisAgent(row) {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      this.$refs.hotTableCmd.hotInstance.setDataAtCell(row, 1, false)

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    checkAllCommands() {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      var i;
      var lg = this.$refs.hotTableCmd.hotInstance.countRows();

      for (i = 0; i < lg; i++) {
        this.$refs.hotTableCmd.hotInstance.setDataAtCell(i, 1, true)
      }

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    uncheckAllCommands() {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      var i;
      var lg = this.$refs.hotTableCmd.hotInstance.countRows();
      for (i = 0; i < lg; i++) {
        this.$refs.hotTableCmd.hotInstance.setDataAtCell(i, 1, false)
      }

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    afterSelectionEndCmd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTableCmd.hotInstance.countCols(); i++) {
          this.$refs.hotTableCmd.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTableCmd.hotInstance.countCols(); i++) {
        this.$refs.hotTableCmd.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTableCmd.hotInstance.render()
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    clearedCmd() {
      this.searchNameCmd = "";

      // Au lieu d'appeler getDataCmd qui fait un appel serveur
      // Simplement réinitialiser le filtre sur les données déjà chargées
      if (this.hotTableCmd) {
        const originalData = this.toObjectCmd.slice(1); // Ignorer l'en-tête
        this.hotTableCmd.loadData(originalData);
      } else if (this.$refs.hotTableCmd && this.$refs.hotTableCmd.hotInstance) {
        this.$refs.hotTableCmd.hotInstance.getPlugin('filters').clearConditions();
        this.$refs.hotTableCmd.hotInstance.getPlugin('filters').filter();
      }
    },
    searchCmd() {
      const query = this.isEmpty(this.searchNameCmd) ? this.searchNameCmd : this.searchNameCmd.toLowerCase();

      if (this.isEmpty(query)) {
        this.clearedCmd();
        return;
      }

      // Determine which table instance to use
      let tableInstance;

      // If we're using the new SweetAlert2 modal
      if (this.hotTableCmd) {
        tableInstance = this.hotTableCmd;
      }
      // If we're using the original Vue modal with refs
      else if (this.$refs.hotTableCmd && this.$refs.hotTableCmd.hotInstance) {
        tableInstance = this.$refs.hotTableCmd.hotInstance;
      }
      // No valid table instance found
      else {
        console.warn("No valid table instance found");
        return;
      }

      let row;
      let col;
      let rLen;
      let cLen;
      let data = tableInstance.getData();
      let array = [];

      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          let x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }

      tableInstance.loadData(array);
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    initdatetime() {
      this.editedItem.startDate = this.editedItem.endDate = moment().toISOString().substr(0, 10);
      this.editedItem.reasonAbsence = "";
      this.editedItem.userId = "";
      this.editedItem.absenceObservations = "";
      this.listMeals = [];
    },
    initCmd() {
      // Initialiser les valeurs par défaut
      this.editedItemCmd.orderDate = moment().toISOString().substr(0, 10);
      this.editedItemCmd.userId = "";
      this.editedItemCmd.nameMeal = "";
      this.editedItemCmd.timeMeal = "Déjeuner";
      this.listMeals = [];

      // Appeler la méthode pour obtenir les menus
      this.getNameMeal();

      // Afficher le modal amélioré
      this.showCommandModal();
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", (this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal) ? this.depthVal.value : this.depthValToday.value)
        sessionStorage.setItem("depthValChoosedt", (this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal) ? this.depthVal.name : this.depthValToday.name)
      }
      this.getData()
    },
    heightDate() {
      if (this.heightVal) {
        sessionStorage.setItem("heightValChoosedd", (this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal) ? this.heightVal.value : this.heightValToday.value)
        sessionStorage.setItem("heightValChoosedt", (this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal) ? this.heightVal.name : this.heightValToday.name)
      }
      this.getData()
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.loading = true
      let valeur = (this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal || this.bDisplayOK_RH || this.bDisplayOK_TSA || this.bDisplayOK_ASSA) ? this.depthVal.value : this.depthValToday.value

      let str;
      if (!(this.bDisplayOK_Corinne || this.bDisplayOK_PointFocal || this.bDisplayOK_RH || this.bDisplayOK_TSA || this.bDisplayOK_ASSA)) {
        str = `${this.$store.getters.user.baseUrl}/order/ordersbydatedepthbetween/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/0/" + sessionStorage.getItem("userId");
      } else {
        str = `${this.$store.getters.user.baseUrl}/order/ordersbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId");
      }

      apiClient
          .get(
              str
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            var restaurateursFull = JSON.parse(sessionStorage.getItem("restaurateursFull"));
            let nameResto;

            newObj.forEach((item) => {
              let s2 = item["originProduct"].toLowerCase();

              for (let i = 0; i < restaurateursFull.length - 1; i++) {
                let s1 = restaurateursFull[i].toLowerCase()
                if (s1.localeCompare(s2) === 0) {
                  nameResto = restaurateursFull[i + 1]
                  break;
                }
              }

              if (this.bDisplayOK_Restaurateur) {
                let s1 = this.sigleRestaurateur.toLowerCase()
                if (s1.localeCompare(s2) === 0) {
                  tabArray.push([
                    item["id"],
                    false,
                    item["userId"],
                    this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                    this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                    this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                    item["shiftName"],
                    item["orderNumber"],
                    this.convertDate(item["orderDate"]),
                    item["timeMeal"],
                    item["nameMeal"],
                    item["priceMeal"],
                    item["observations"],
                    this.datefull(item["creationDate"]),
                    item["originUser"],
                    item["anonyme"],
                    nameResto
                  ])
                }
              } else {
                tabArray.push([
                  item["id"],
                  false,
                  item["userId"],
                  this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                  this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                  this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                  item["shiftName"],
                  item["orderNumber"],
                  this.convertDate(item["orderDate"]),
                  item["timeMeal"],
                  item["nameMeal"],
                  item["priceMeal"],
                  item["observations"],
                  this.datefull(item["creationDate"]),
                  item["originUser"],
                  item["anonyme"],
                  nameResto
                ])
              }
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
            this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
          })
          .catch(() => {
            this.loading = false
          });
    },
    // Amélioration de la méthode getNameMeal pour éviter les rechargements inutiles
    getNameMeal() {
      // Add timestamp tracking for race condition prevention
      const requestTime = Date.now();
      this.lastMenuRequestTime = requestTime;

      if (!this.isEmpty(this.editedItemCmd.orderDate) && !this.isEmpty(this.editedItemCmd.timeMeal)) {
        // Keep the original API call structure
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/product/namemeal/` +
                this.editedItemCmd.orderDate + "/" +
                this.editedItemCmd.timeMeal + "/" +
                sessionStorage.getItem("userId")
            )
            .then(response => {
              // NEW: Only process if this is the most recent request
              if (requestTime !== this.lastMenuRequestTime) {
                console.log('Ignoring outdated menu response');
                return;
              }

              // ORIGINAL: Keep all the original logic exactly as it was
              let newObj = response.data.datas;

              // Vérifier si les menus ont changé avant de mettre à jour l'interface
              const currentMenus = this.listMeals.join(',');
              const newMenus = !this.isEmpty(newObj) ? newObj : '';

              // Si rien n'a changé, ne rien faire pour éviter le scintillement
              if (currentMenus === newMenus && this.bYesMeal === !this.isEmpty(newObj)) {
                return;
              }

              if (!this.isEmpty(newObj)) {
                // Menus disponibles - mettre à jour uniquement si nécessaire
                const newListMeals = newObj.split(',');
                this.listMeals = newListMeals;

                // Ne changer la valeur que si nécessaire
                if (this.editedItemCmd.nameMeal !== newListMeals[0]) {
                  this.editedItemCmd.nameMeal = newListMeals[0];
                }

                // Mettre à jour les états
                this.bYesMeal = true;
                this.isListMeal = false;

                // Mettre à jour le sélecteur de menu subtilement
                const mealNameSelect = document.getElementById('mealName');
                if (mealNameSelect) {
                  // Vérifier si les options ont changé avant de les recréer
                  const currentOptions = Array.from(mealNameSelect.options).map(opt => opt.value);
                  if (JSON.stringify(currentOptions) !== JSON.stringify(newListMeals)) {
                    // Sauvegarder la sélection actuelle
                    const currentSelection = mealNameSelect.value;

                    // Mettre à jour les options
                    while (mealNameSelect.firstChild) {
                      mealNameSelect.removeChild(mealNameSelect.firstChild);
                    }

                    newListMeals.forEach(meal => {
                      const option = document.createElement('option');
                      option.value = meal;
                      option.textContent = meal;
                      mealNameSelect.appendChild(option);
                    });

                    // Restaurer la sélection si possible, sinon prendre la première valeur
                    mealNameSelect.value = newListMeals.includes(currentSelection) ?
                        currentSelection : newListMeals[0];
                  }

                  mealNameSelect.disabled = false;
                }

                // Charger les données des salariés uniquement la première fois
                if (!this.hotTableCmd || this.hotTableCmd.getData().length === 0) {
                  this.getDataCmd();
                }
              } else {
                // Aucun menu disponible
                if (this.bYesMeal) { // Afficher l'alerte seulement si l'état change
                  this.textCmd = "Il n'y a pas de menu pour ce jour et cet horaire.";
                  this.showInlineAlert('warning');
                }

                this.listMeals = [];
                this.editedItemCmd.nameMeal = "";
                this.bYesMeal = false;
                this.isListMeal = true;

                // Désactiver le sélecteur
                const mealNameSelect = document.getElementById('mealName');
                if (mealNameSelect) {
                  if (mealNameSelect.options.length !== 1 ||
                      mealNameSelect.options[0].textContent !== 'Pas de menu disponible') {
                    mealNameSelect.innerHTML = '<option value="" disabled selected>Pas de menu disponible</option>';
                  }
                  mealNameSelect.disabled = true;
                }

                // Charger les données des salariés uniquement la première fois
                if (!this.hotTableCmd || this.hotTableCmd.getData().length === 0) {
                  this.getDataCmd();
                }
              }
            })
            .catch((error) => {
              // NEW: Only handle error if this is still the most recent request
              if (requestTime !== this.lastMenuRequestTime) {
                return;
              }

              // ORIGINAL: Keep the original error handling
              console.error("Erreur lors du chargement des menus:", error);

              this.isListMeal = true;
              this.editedItemCmd.nameMeal = "";
              this.bYesMeal = false;

              this.textCmd = "Erreur lors du chargement des menus.";
              this.showInlineAlert('warning');
            });
      } else {
        this.textCmd = "Sélectionnez une date et un horaire de repas.";
        this.showInlineAlert('warning');
        this.editedItemCmd.nameMeal = "";
        this.bYesMeal = false;
      }
    },

// Nouvelle méthode pour afficher les alertes à l'intérieur du modal
    showInlineAlert(type) {
      // Créer ou obtenir le conteneur d'alerte
      let alertContainer = document.getElementById('modal-inline-alert');
      if (!alertContainer) {
        alertContainer = document.createElement('div');
        alertContainer.id = 'modal-inline-alert';

        // Insérer l'alerte au début du formulaire
        const formContainer = document.querySelector('.command-form');
        if (formContainer) {
          formContainer.insertBefore(alertContainer, formContainer.firstChild);
        }
      }

      // Définir le style et le contenu de l'alerte
      const backgroundColor = type === 'info' ? '#4CAF50' : '#F44336';
      const icon = type === 'info' ? 'success' : 'warning';

      alertContainer.innerHTML = `
    <div style="
      margin-bottom: 20px;
      padding: 12px 16px;
      border-radius: 4px;
      background-color: ${backgroundColor};
      color: white;
      font-weight: 500;
      display: flex;
      align-items: center;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    ">
      <i class="v-icon mdi mdi-${icon}" style="margin-right: 10px; font-size: 20px;"></i>
      ${this.textCmd}
      <span style="margin-left: auto; cursor: pointer;" onclick="document.getElementById('modal-inline-alert').remove()">×</span>
    </div>
  `;

      // Auto-fermeture après 5 secondes
      setTimeout(() => {
        const alertEl = document.getElementById('modal-inline-alert');
        if (alertEl) alertEl.remove();
      }, 5000);
    },
    affectation(row) {
      var data = this.$refs.hotTable.hotInstance.getData()[row];

      this.listMeals = []
      this.isListMeal = true;
      if (!this.isEmpty(this.editedItemCmd.orderDate) && !this.isEmpty(this.editedItemCmd.timeMeal)) {
        this.loading = true
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/product/namemeal/` + this.editedItemCmd.orderDate + "/" + this.editedItemCmd.timeMeal + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              this.loading = false
              let newObj = response.data.datas;

              if (!this.isEmpty(newObj)) {
                // Menus disponibles...
                this.listMeals = this.isEmpty(newObj) ? [] : newObj.split(',')
                this.editedItemCmd.nameMeal = this.listMeals[0]
                this.bYesMeal = true
                this.isListMeal = false

                // Toujours recharger les données (sans condition)
                this.getDataCmd();
              } else {
                // Aucun menu disponible...
                this.textCmd = "Il n'y a pas de menu pour ce jour et cet horaire.";
                this.showInlineAlert('warning')
                this.editedItemCmd.nameMeal = ""
                this.bYesMeal = false
                this.isListMeal = true

                // Toujours recharger les données (sans condition)
                this.getDataCmd();
              }
            })
            .catch(() => {
              this.loading = false
              this.isListMeal = false
              this.editedItemCmd.nameMeal = ""
              this.bYesMeal = true
              this.getDataCmd()
            });
      } else {
        this.textCmd = "Il n y a pas de menu pour ce jour et cet horaire.";
        this.showAlertCmd('warning')
        this.editedItemCmd.nameMeal = ""
        this.bYesMeal = false
        this.getDataCmd()
      }
    },
    getDataCmd() {
      // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = true;

      apiClient
          .get(`${this.$store.getters.user.baseUrl}/account/readytoorder/` +
              this.editedItemCmd.orderDate + "/" +
              this.editedItemCmd.timeMeal + "/1/" +
              sessionStorage.getItem("userId"))
          .then(response => {
            let tabArray = [];
            let newObj = response.data.datas;

            // Formater les données comme avant
            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                false,
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" :
                    item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                item["shiftName"],
                item["observations"]
              ]);
            });

            // Charger les données dans la table
            if (this.hotTableCmd) {
              // ❌ SUPPRIMER tout le système de hook afterRender
              this.hotTableCmd.loadData(tabArray);
            }

            // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = false;

            this.toObjectCmd = [this.hotSettingsCmd.colHeaders,
              ...(this.hotTableCmd ? this.hotTableCmd.getData() : [])];
          })
          .catch(() => {
            // ❌ SUPPRIMER CETTE LIGNE : this.loading2 = false;
          });
    },
    daysIntoYear(date) {
      return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    onCancel() {
      console.log("User cancelled the loader.")
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.$refs.hotTable.hotInstance.loadData([])
      this.toObject = [this.hotSettings.colHeaders, ...[]]
      this.searchNameCmd = ""
      this.refresh()
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    AlertColorCmd(typeCmd) {
      return typeCmd === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertCmd(typeCmd) {
      this.typeCmd = typeCmd

      let timer = this.showAlertCmd.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlertCmd.timer = setTimeout(() => {
        this.typeCmd = null
      }, 20000)

      this.elapseCmd = 1
      let t = this.showAlertCmd.t
      if (t) {
        clearInterval(t)
      }

      this.showAlertCmd.t = setInterval(() => {
        if (this.elapseCmd === 3) {
          this.elapseCmd = 0
          clearInterval(this.showAlertCmd.t)
        } else {
          this.elapseCmd++
        }
      }, 5000)
    },
    dismissible_close_Cmd() {
      this.elapseCmd = 3
      clearTimeout(this.showAlertCmd.timer)
      clearInterval(this.showAlertCmd.t)
      this.typeCmd = null
      this.searchNameCmd = ""
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    closeAlertCmd() {
      this.alertCmd = false
      this.textCmd = ""
      this.errorsCmd = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterLoadDataCmd() {
      this.toObjectCmd = [this.hotSettingsCmd.colHeaders, ...this.$refs.hotTableCmd.hotInstance.getData()]
    },
    afterFilterCmd() {
      this.toObjectCmd = [this.hotSettingsCmd.colHeaders, ...this.$refs.hotTableCmd.hotInstance.getData()]
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let sBody;

        if (changes[0][1] !== 1) {
          sBody = "Confirmez la modification de la commande."
        } else {
          sBody = "Confirmez l'annulation de la commande."
        }

        let message = {
          title: 'Fenêtre de confirmation',
          body: sBody
        };

        //  /orderitem/{id}/{type}/{senderId}")

        this.$dialog
            .confirm(message)
            .then(dialog => {
              this.loading = true
              let obj = {}
              let newObj = {}
              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              if (changes[0][1] === 1) {
                apiClient
                    .delete(
                        `${this.$store.getters.user.baseUrl}/order/deleteorderitem/` + obj[0] + `/` + "DELETE/" + sessionStorage.getItem("userId")
                    )
                    .then(res => {
                      dialog.close();
                      this.loading = false
                      if (res.data.status === 200) {
                        this.color = "#009688"
                        this.text = res.data.message;
                        this.showAlert('info')
                        this.depthDate()
                      } else {
                        this.color = "#F44336"
                        this.alert = true
                        this.text = res.data.message;
                        this.dialog = false;
                        this.initdatetime()

                        let myData = this.$refs.hotTable.hotInstance.getData()
                        myData[changes[0][0]][changes[0][1]] = changes[0][2]
                        this.$refs.hotTable.hotInstance.loadData(myData)
                        this.showAlert('warning')
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)

                      this.alert = true
                      this.color = "#F44336"
                      this.text = err.data.message;
                      this.loading = false
                      this.showAlert('warning')
                    });
              } else if (changes[0][1] === 12) {
                newObj = {
                  "id": obj[0],
                  "observations": obj[12]
                }

                apiClient
                    .post(
                        `${this.$store.getters.user.baseUrl}/order/modiforderitemobservations/` + sessionStorage.getItem("userId"),
                        newObj
                    )
                    .then(res => {
                      dialog.close();
                      this.loading = false
                      if (res.data.status === 200) {
                        this.color = "#009688"
                        this.text = res.data.message;
                        this.showAlert('info')
                        this.depthDate()
                      } else {
                        this.color = "#F44336"
                        this.alert = true
                        this.text = res.data.message;
                        this.dialog = false;
                        this.initdatetime()

                        let myData = this.$refs.hotTable.hotInstance.getData()
                        myData[changes[0][0]][changes[0][1]] = changes[0][2]
                        this.$refs.hotTable.hotInstance.loadData(myData)
                        this.showAlert('warning')
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)

                      this.alert = true
                      this.color = "#F44336"
                      this.text = err.data.message;
                      this.loading = false
                      this.showAlert('warning')
                    });
              } else if (changes[0][1] === 2) {
                newObj = {
                  "id": obj[0],
                  "userId": obj[2]
                }

                apiClient
                    .post(
                        `${this.$store.getters.user.baseUrl}/order/affectorder2agent/` + sessionStorage.getItem("userId"),
                        newObj
                    )
                    .then(res => {
                      dialog.close();
                      this.loading = false
                      if (res.data.status === 200) {
                        this.color = "#009688"
                        this.text = res.data.message;
                        this.showAlert('info')
                        this.depthDate()
                      } else {
                        this.color = "#F44336"
                        this.alert = true
                        this.text = res.data.message;
                        this.dialog = false;
                        this.initdatetime()

                        let myData = this.$refs.hotTable.hotInstance.getData()
                        myData[changes[0][0]][changes[0][1]] = changes[0][2]
                        this.$refs.hotTable.hotInstance.loadData(myData)
                        this.showAlert('warning')
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)

                      this.alert = true
                      this.color = "#F44336"
                      this.text = err.data.message;
                      this.loading = false
                      this.showAlert('warning')
                    });
              }
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
            });
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de la commande.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/order/deleteorderitem/` + rowId[0] + `/` + "DELETE/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                    this.depthDate()
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((err) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = err;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
          });
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    creer() {
      this.loading = true
      const dataToSave = {
        userId: this.editedItem.userId,
        startDate: moment(this.editedItem.startDate).format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(this.editedItem.endDate).format("YYYY-MM-DD HH:mm:ss"),
        reasonAbsence: this.editedItem.reasonAbsence,
        absenceObservations: this.editedItem.absenceObservations
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/absence/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false

            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.dialog = false;
              this.editedItem.userId =
                  this.editedItem.startDate =
                      this.editedItem.endDate =
                          this.editedItem.reasonAbsence =
                              this.editedItem.absenceObservations = "";

              this.showAlert('info')
              this.depthDate();
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;
              this.editedItem.userId =
                  this.editedItem.startDate =
                      this.editedItem.endDate =
                          this.editedItem.reasonAbsence =
                              this.editedItem.absenceObservations = "";

              this.showAlert('warning')
            }
          })
          .catch(error => {
            this.alert = true
            this.text = error;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    exportXLS() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true

      let toObjectFinal = []

      toObjectFinal.push(
          [
            "Date commande",
            "Matricule",
            "Nom",
            "Prénoms",
            "Brigade",
            "Horaire repas",
            "Nom du menu",
            this.bDisplayOK_Corinne ? "Prix du menu" : null
          ]
      )

      for (let i = 1; i < this.toObject.length; i++) {
        toObjectFinal.push([
          this.toObject[i][8],
          this.toObject[i][2],
          this.toObject[i][3],
          this.toObject[i][4],
          this.toObject[i][5],
          this.toObject[i][9],
          this.toObject[i][10],
          this.bDisplayOK_Corinne ? this.toObject[i][11] : null
        ])
      }

      const datas = XLSX.utils.json_to_sheet(toObjectFinal, {skipHeader: true});
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Commandes_détails") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Commandes_détails.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    pad(n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    onexportThalia() { // On Click Excel download button
      class Counter extends Map {
        constructor(iter, key = null) {
          super();
          this.key = key || (x => x);
          for (let x of iter) {
            this.add(x);
          }
        }

        add(x) {
          x = this.key(x);
          this.set(x, (this.get(x) || 0) + 1);
        }
      }

      let byMat = new Counter(this.toObjectNoHeader, x => x[2]);
      //console.log("byMat", byMat);

      var datasTmp = []

      for (const [clef, valeur] of byMat) {
        if (!listGuess.includes(clef)) {
          datasTmp.push([
            this.pad(clef, 3),
            "515",
            "P",
            valeur
          ])
        }
      }

      if (datasTmp.length === 0) {
        this.text = "Il n'y a aucune commande disponible pour la période choisie.";
        this.showAlert('warning')
        return;
      }

      var datas = XLSX.utils.json_to_sheet(datasTmp, {origin: 'A1', skipHeader: true})

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Export_nbr_commandes") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Export_nbr_commandes_Thalia.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
  },
}
;
</script>

<style>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

/* Style amélioré pour les boutons avec meilleur contraste */
.custom-btn {
  width: 222px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); /* Ombre sur le texte pour améliorer la lisibilité */
  font-weight: 600; /* Texte plus gras */
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #FFFFFF !important; /* Blanc plus pur au survol */
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2); /* Ombre légère au survol */
}

/* Styles améliorés pour les inputs avec meilleur contraste */
.v-text-field.v-text-field--filled .v-label,
.v-select.v-select--filled .v-label {
  color: rgba(0, 0, 0, 0.7) !important; /* Étiquette plus foncée */
}

.v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
.v-select.v-select--filled > .v-input__control > .v-input__slot {
  background: #f5f5f5 !important; /* Fond plus clair pour le contraste */
  border: 1px solid #e0e0e0;
}

.v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot,
.v-select.v-select--filled:hover > .v-input__control > .v-input__slot {
  background: #ffffff !important; /* Blanc au survol */
}

.v-text-field--filled.v-input--is-focused > .v-input__control > .v-input__slot,
.v-select--filled.v-input--is-focused > .v-input__control > .v-input__slot {
  background: #ffffff !important; /* Blanc quand focus */
  border-color: #009688; /* Couleur de bordure cohérente avec le thème */
}

.text-cmd-white input {
  color: #000000 !important; /* Texte noir pour contraste maximal */
  font-size: 17px;
  font-weight: bold;
  background-color: #f9f9f9 !important; /* Fond légèrement grisé */
}

.text-white input {
  color: #000000 !important; /* Texte noir au lieu de blanc */
  font-weight: bold;
  background-color: #f9f9f9 !important; /* Fond légèrement grisé */
}

/* Amélioration des styles pour le modal SweetAlert */
.swal2-popup .form-group input,
.swal2-popup .form-group select {
  background-color: rgba(255, 255, 255, 0.25) !important; /* Fond plus blanc pour les inputs */
  font-weight: 600 !important; /* Texte plus gras */
  color: #333333 !important; /* Texte plus foncé */
  text-shadow: none !important; /* Pas d'ombre sur le texte */
}

.swal2-popup .form-group label {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3); /* Ombre sur les labels pour améliorer la lisibilité */
  letter-spacing: 0.5px; /* Espacement des lettres pour améliorer la lisibilité */
  font-weight: 700 !important; /* Label en gras */
}

.text-cmd-white input {
  color: #f0f0f0 !important;
  font-size: 17px;
  font-weight: bold;
}

.text-white input {
  color: white !important;
  font-weight: bold;
}

.colRed {
  color: #D32F2F !important;
  font-weight: bold;
}


.colGreen {
  color: #028A0F !important;
  font-weight: bold;
}

.colYellow {
  background-color: #FFF9C4 !important;
  pointer-events: fill;
}

.colBrown {
  background-color: #D7CCC8 !important;
  pointer-events: none
}

/* Styles pour centrer le calendrier flatpickr */
.centered-calendar {
  left: 50% !important;
  transform: translateX(-50%) !important;
  position: fixed !important;
  top: 40% !important; /* Position verticale centrée */
  transform: translate(-50%, -50%) !important; /* Centrage parfait */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important; /* Ombre plus prononcée */
  border-radius: 8px !important; /* Coins arrondis */
}

/* Styles supplémentaires pour améliorer l'apparence */
.flatpickr-calendar {
  font-family: 'Roboto', sans-serif !important;
  width: 340px !important; /* Largeur augmentée pour éviter la troncature */
  padding: 10px !important;
  background-color: #ffffff !important;
}

/* Ajustement de la cellule des jours pour éviter la troncature */
.flatpickr-days {
  width: 100% !important; /* S'assurer que le conteneur prend toute la largeur */
  max-width: 320px !important; /* Limiter la largeur maximale */
  padding: 0 6px !important; /* Ajouter un peu de padding horizontal */
}

.dayContainer {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: space-around !important; /* Distribuer l'espace uniformément */
}

/* Ajuster la taille et le centrage des jours */
.flatpickr-day {
  border-radius: 50% !important; /* Jours parfaitement ronds */
  margin: 2px !important;
  height: 38px !important; /* Légèrement réduit */
  line-height: 38px !important;
  width: 38px !important; /* Légèrement réduit */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: 14px !important; /* Taille de police réduite */
}

.flatpickr-day.selected {
  background-color: #009688 !important; /* Couleur de thème pour le jour sélectionné */
  border-color: #009688 !important;
}

.flatpickr-day:hover {
  background-color: #e0f2f1 !important; /* Couleur de thème plus claire au survol */
}

.flatpickr-months .flatpickr-month {
  background-color: #009688 !important; /* En-tête en couleur de thème */
  color: white !important;
  border-radius: 5px 5px 0 0 !important;
  height: 50px !important;
}

.flatpickr-current-month {
  padding-top: 10px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

.flatpickr-monthDropdown-months {
  color: white !important;
  font-weight: 600 !important;
}

.flatpickr-weekday {
  background-color: transparent !important;
  color: #546E7A !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

/* Améliore les flèches de navigation */
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  top: 5px !important;
  padding: 5px !important;
  color: white !important;
  fill: white !important;
}

.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  opacity: 1 !important;
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
}

/* Styles spécifiques pour Flatpickr en mode responsive */
@media (max-width: 768px) {
  .flatpickr-calendar {
    width: 300px !important; /* Largeur réduite pour les petits écrans */
    max-width: 95vw !important; /* Limitation à 95% de la largeur de la fenêtre */
    font-size: 14px !important; /* Police légèrement plus petite */
  }

  .flatpickr-day {
    height: 35px !important;
    line-height: 35px !important;
    width: 35px !important;
    max-width: 35px !important;
    font-size: 13px !important;
  }

  /* Améliorer l'accessibilité des flèches sur mobile */
  .flatpickr-months .flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month {
    height: 40px !important;
    width: 40px !important;
    padding: 10px !important; /* Zone de toucher plus grande */
  }
}
</style>